import type { IcmsUfLegalResponse, PreviaConversaoResponse, TributosReformaResponse, TributosReformaQuery } from '@triade/contracts';
import { useConsulta, useMutacao } from './base';

/** Tabela legal do ICMS por UF (27 linhas) na data. Sem `data` = hoje. */
export function useIcmsLegal(data?: string) {
  return useConsulta<IcmsUfLegalResponse[]>(['tabelas-preco', 'icms-legal'], '/tabelas-preco/icms-legal', { query: data ? { data } : {} });
}

/** CBS, IBS e IS em somente leitura (contexto da reforma). */
export function useTributosReforma(q: TributosReformaQuery = {}, ativo = true) {
  return useConsulta<TributosReformaResponse>(['tabelas-preco', 'tributos-reforma'], '/tabelas-preco/tributos-reforma', { query: q, ativo });
}

/** Previa da conversao LEGADO -> ESTRUTURADO da vigencia em aberto (nada e gravado). So consulta quando `ativo`. */
export function usePreviaConversao(tabelaId: string, ativo: boolean) {
  return useConsulta<PreviaConversaoResponse>(['tabelas-preco', tabelaId, 'previa-conversao'], `/tabelas-preco/${tabelaId}/previa-conversao`, {
    query: { amostra: 5 },
    ativo,
  });
}

/** Confirma a conversao: POST /vigencias com o `corpo` da previa, trocando so `validFrom` e `motivo`. */
export function useConfirmarConversao() {
  return useMutacao<unknown, { tabelaId: string; validFrom: string; motivo?: string; corpo: NonNullable<PreviaConversaoResponse['corpo']> }>({
    metodo: 'POST',
    caminho: (v) => `/tabelas-preco/${v.tabelaId}/vigencias`,
    corpo: (v) => ({ ...v.corpo, validFrom: v.validFrom, ...(v.motivo ? { motivo: v.motivo } : {}) }),
    invalidar: [['tabelas-preco']],
  });
}
